function FittingStationTracker(analytics) {
	'use strict';

    this.analytics       = analytics;
    this.$fittingStation = $('#fitting-station');
    this.$searchSubmit   = $('#find-fitting-station');
    this.$searchInput    = this.$fittingStation.find('.fitting-station-finder__input');
}

FittingStationTracker.prototype = {
	init: function () {
		'use strict';

        if (!this.$fittingStation.length) {
            return;
        }

        this.initStationSearch();
	},

    initAsync: function () {
        'use strict';
        this.initMapInteractionTracking();
    },

  	/**
     * @return {FittingStationTracker}
     */
    initStationSearch: function() {
        'use strict';

        this.$searchSubmit.on('click', $.proxy(this.trackStationSearch, this));
        this.$searchInput.on('keypress', $.proxy(function (event) {

            if (event.which === 13) {
                this.trackStationSearch();
            }

        }, this));

        return this;
    },

    /**
     * @return {FittingStationTracker}
     */
    initMapInteractionTracking: function () {
        'use strict';

        this.map = TYROOLA.page.getMap();

        google.maps.event.addListener(this.map, 'dragend', this.trackMapPan.bind(this));
        google.maps.event.addListener(this.map, 'zoom_changed', this.trackZoomChange.bind(this));

        return this;
    },

    /**
     * User panning of the map
     */
    trackMapPan: function () {
        'use strict';
        this.analytics.track('FittingStation', 'Map Pan');
    },

    /**
     * Zoom level changed
     */
    trackZoomChange: function () {
        'use strict';
        this.analytics.track('FittingStation', 'Zoom Change', this.map.getZoom(), 1);
    },

    /**
     * @param  {Object} event
     * @return {CheckoutTracker}
     */
    trackStationSearch: function () {
    	'use strict';

        this.analytics.track(
            'FittingStation',
            'Search',
            this.$searchInput.val(),
            1
        );

        return this;
    }
};

export default FittingStationTracker;